import { ClientConfigResponse, EmulateBanner } from '@dav-model/api/response/client-config.response.model';

import * as ConfigActions from './config.actions';

export interface State {
  error: string;
  success: boolean;
  clientConfig: ClientConfigResponse;
  initialClientConfig: ClientConfigResponse;
  dealerView: boolean;
}

const InitialState: State = {
  error: '',
  success: false,
  clientConfig: new ClientConfigResponse(),
  initialClientConfig: new ClientConfigResponse(),
  dealerView: false,
};

export function reducer(state = InitialState, action: ConfigActions.All): State {
  switch (action.type) {
    case ConfigActions.GET_INITIAL_LAYOUT_SUCCESS: {
      const payload = {
        ...action.payload,
        css: { ...action.payload.css, emulateBanner: action.payload.css.emulateBanner || new EmulateBanner() },
      };

      return {
        ...state,
        clientConfig: payload,
        initialClientConfig: payload,
        success: true,
        // add more when you start calling the effects API for initial layout
      };
    }

    // will update configurations for testing purposes.. call reset layout when
    // navigating away from admin page
    case ConfigActions.TEST_LAYOUT: {
      return {
        ...state,
        clientConfig: action.payload,
      };
    }

    case ConfigActions.RESET_LAYOUT: {
      return {
        ...state,
        clientConfig: state.initialClientConfig,
      };
    }

    case ConfigActions.TOGGLE_DEALER_VIEW: {
      return {
        ...state,
        dealerView: action.payload,
      };
    }

    case ConfigActions.CONFIG_FAILURE: {
      return {
        ...state,
        success: false,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}


